module.exports = __webpack_public_path__ + "img/signup-parta-3m-before-retire.df109ac.png";